export type RehearsalState =
  | 'idle'
  | 'requesting_mic'
  | 'recording'
  | 'paused'
  | 'completed'
  | 'saved';

export type RehearsalEvent =
  | { type: 'START_REHEARSAL' }
  | { type: 'MIC_GRANTED' }
  | { type: 'MIC_DENIED' }
  | { type: 'PAUSE' }
  | { type: 'RESUME' }
  | { type: 'DONE' }
  | { type: 'SAVE' }
  | { type: 'DISCARD' }
  | { type: 'REHEARSE_AGAIN' }
  | { type: 'START_OVER' };

const transitions: Record<
  RehearsalState,
  Partial<Record<RehearsalEvent['type'], RehearsalState>>
> = {
  idle: {
    START_REHEARSAL: 'requesting_mic',
  },
  requesting_mic: {
    MIC_GRANTED: 'recording',
    MIC_DENIED: 'idle',
  },
  recording: {
    PAUSE: 'paused',
    DONE: 'completed',
    START_OVER: 'requesting_mic',
  },
  paused: {
    RESUME: 'recording',
    DONE: 'completed',
    START_OVER: 'requesting_mic',
  },
  completed: {
    SAVE: 'saved',
    DISCARD: 'idle',
    REHEARSE_AGAIN: 'requesting_mic',
  },
  saved: {},
};

export function transition(state: RehearsalState, event: RehearsalEvent): RehearsalState {
  return transitions[state][event.type] ?? state;
}
